import React, {  Component } from 'react';
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';

class ItemScoringDef extends Component {

    constructor(props) {
        super(props);
        this.state = {
            itemDefId: props.itemDefId,
            domainDefId: props.domainDefId,
            domainName: props.domainName,
            indexItemDefId: props.indexItemDefId,
            scoreVariant: props.scoreVariant,
            asdScore: props.asdScore,
            asdWeight: props.asdWeight, 
            asdDomainScore: props.asdDomainScore,
            asdDomainWeight: props.asdDomainWeight
        }
    }

    scoreVariantChangeHandler = (e) => {
        this.props.changeHandler(this.state.indexItemDefId, e.target.value, this.state.asdScore, this.state.asdWeight, this.state.asdDomainScore, this.state.asdDomainWeight)
        this.setState({ scoreVariant: e.target.value });
    }

    asdScoreChangeHandler = (e) => {
        this.props.changeHandler(this.state.indexItemDefId, this.state.scoreVariant, e.target.checked, this.state.asdWeight, this.state.asdDomainScore, this.state.asdDomainWeight)
        this.setState({ asdScore: e.target.checked });
    }

    asdWeightChangeHandler = (e) => {
        if (e.target.value == "") {
            e.target.value = 0;
        }
        this.props.changeHandler(this.state.indexItemDefId, this.state.scoreVariant, this.state.asdScore, e.target.value, this.state.asdDomainScore, this.state.asdDomainWeight)
        this.setState({ asdWeight: e.target.value });
    }

    asdDomainScoreChangeHandler = (e) => {
        this.props.changeHandler(this.state.indexItemDefId, this.state.scoreVariant, this.state.asdScore, this.state.asdWeight, e.target.value, this.state.asdDomainWeight)
        this.setState({ asdDomainScore: e.target.value });
    }

    asdDomainWeightChangeHandler = (e) => {
        if (e.target.value == "") {
            e.target.value = 0;
        }
        this.props.changeHandler(this.state.indexItemDefId, this.state.scoreVariant, this.state.asdScore, this.state.asdWeight, this.state.asdDomainScore, e.target.value)
        this.setState({ asdDomainWeight: e.target.value });
    }

    render() {
        // Build the options list (each item is a string)
        let optionList = null;
        if (this.props.scoreVariantOptions != null) {
            optionList = this.props.scoreVariantOptions.map((item) => {
                return (
                    <option>{item}</option>
                )
            });
        }

        return (
            <tr>
                <td>{this.props.domainName}</td>
                <td>{this.props.assessmentArea}</td>
                <td>
                    <FormControl
                        as="select"
                        title="Score Variants"
                        value={this.state.scoreVariant}
                        onChange={this.scoreVariantChangeHandler}
                    >
                        {optionList}
                    </FormControl>
                </td>
                <td>
                    <Form.Check type="checkbox" label="" onChange={this.asdScoreChangeHandler} checked={this.state.asdScore}/>
                </td>
                <td>
                    <Form.Control 
                        type="number"
                        placeholder="Floating point ASD weight"
                        defaultValue={this.state.asdWeight}
                        onBlur={this.asdWeightChangeHandler}
                    />
                </td>
                <td>
                    <Form.Control
                        type="text"
                        defaultValue={this.state.asdDomainScore}
                        onBlur={this.asdDomainScoreChangeHandler} />
                </td>
                <td>
                    <Form.Control
                        type="number"
                        placeholder="Floating point ASD domain weight"
                        defaultValue={this.state.asdDomainWeight}
                        onBlur={this.asdDomainWeightChangeHandler}
                    />
                </td>
            </tr>  
        )
    }
}

export default ItemScoringDef;


// WEBPACK FOOTER //
// ./src/components/AdminHome/ItemScoringDef.js